import { useEffect, useState } from 'react'

function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false)
  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
    const apply = () => setReduced(mq.matches)
    apply()
    mq.addEventListener('change', apply)
    return () => mq.removeEventListener('change', apply)
  }, [])
  return reduced
}

/**
 * Brand AI avatar — only mount while agent panel is open (caller).
 * WebP primary, GIF fallback, poster when prefers-reduced-motion.
 */
export function AgentAvatar() {
  const reduced = usePrefersReducedMotion()

  if (reduced) {
    return (
      <img
        className="rd-agent-avatar-img"
        src="/ai/7gc-ai-avatar-poster.png"
        width={170}
        height={170}
        alt="7GC AI asistent"
        decoding="async"
      />
    )
  }

  return (
    <picture>
      <source srcSet="/ai/7gc-ai-avatar-256.webp" type="image/webp" />
      <img
        className="rd-agent-avatar-img"
        src="/ai/7gc-ai-avatar.gif"
        width={170}
        height={170}
        alt="7GC AI asistent"
        decoding="async"
      />
    </picture>
  )
}
